import React from "react";
import styled from "styled-components";
import moment from "moment";
import { translate, language } from "../../../../../_helpers/general.helper";
import FloorplanDetails from "./Details.Floorplan";
import { useWindowSize } from "../../../Utility/hooks";

const FloorplanImageWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  text-align: start;
  padding-top: 26px;
  border-bottom: 1px solid #dfdfdf;
  height: 134px;

  &:focus-visible {
    ${(props) =>
      !props.selected &&
      `box-shadow: 0 0 2px 2px ${
        props.theme.themeColors[props.theme.activeTheme].focusColor
      };`}
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    padding-top: 10px;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    margin-right: 30px;
    height: 218px;
    width: 740px;
    padding: 0;
    grid-template-columns: 1fr 2fr;
    border-radius: 8px;
  }

  .date {
    color: #4c566f;
    font-family: "DM Sans";
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 4px;

    @media screen and (min-width: ${(props) =>
        props.theme.screenSizes.breakLaptop}) {
      font-size: 14px;
      .date-flag {
        font-size: 13px !important;
      }
    }

    .date-flag {
      display: inline-block;
      padding: 3px 4px;
      color: #fff;
      font-family: "DM Sans";
      font-size: 12px;
      font-weight: 500;
      text-transform: capitalize;
      border-radius: 2px;
      background: #42accd;
      text-transform: capitalize;
      margin-left: 2px;
    }

    .not-available {
      display: inline-block;
      background-color: #eaeaea;
      color: #495057;
      font-family: "DM Sans";
      font-size: 13px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      letter-spacing: 0.13px;
      text-transform: capitalize;
      padding: 3px 4px;
      border-radius: 2px;
    }

    .available {
      display: inline-block;
      background-color: #42accd;
      color: white;
      font-family: "DM Sans";
      font-size: 13px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      letter-spacing: 0.13px;
      text-transform: capitalize;
      padding: 3px 4px;
      border-radius: 2px;
    }
  }

  .title {
    color: var(--Primary-Dark-Blue);
    font-family: "DM Sans";
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;

    @media screen and (min-width: ${(props) =>
        props.theme.screenSizes.breakLaptop}) {
      font-size: 22px;
    }
  }

  .image-container {
    display: flex;
    justify-content: start;
    height: 92px;
    height: 100%;
    position: relative;

    justify-content: center;
    align-items: start;

    .floorploan-banner {
        position: absolute;
        top: -15px;
        z-index: 100;
        background: white;
        left: 0px;
        padding: 3px 8px;
        text-align: center;
        border-radius: 0px 28px 28px 0px;
        border: 1px solid #DFDFDF;
        background: rgba(255, 255, 255, 0.90);
        box-shadow: 0px 2px 4px 0px rgba(159, 159, 159, 0.25);
        color: #0F0538;
        font-family: "DM Sans";
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

        @media screen and (min-width: ${(props) =>
        props.theme.screenSizes.breakSmall}) {
           .floorploan-banner {
             top: 0px;
           }
        }

       @media screen and (min-width: ${(props) =>
        props.theme.screenSizes.breakLaptop}) {
           .floorploan-banner {
             top: 15px;
           }
        }

    .banner-image {
       margin-right: 5px;
    }

    @media screen and (min-width: ${(props) =>
        props.theme.screenSizes.breakLaptop}) {
      height: 216px;
      width: 279px;
      padding: 0;
      box-shadow: 2.37px 2.37px 4.74px 0px rgba(169, 169, 169, 0.25);
      border: 1px solid #dfdfdf;
      border-radius: 8px;
      background-color: white;
    }
  }
`;

const FloorplanImage = styled.img`
  background: white;
  pointer-events: none;
  outline: none;
  box-sizing: border-box;
  object-fit: contain;
  max-width: 100%;
  height: 92px;

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    height: 115px;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    height: 208px;
    max-height: unset;
    margin-left: 0;
    border: none;
    border-radius: 8px;
  }
`;

const FloorplanInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 92px;
  padding-right: 10px;

  .price-wrapper {
    color: #4c566f;
    font-family: "DM Sans";
    font-size: 12px;

    &.no-price {
      font-size: 12px;
      line-height: 16px;
    }

    @media screen and (min-width: ${(props) =>
        props.theme.screenSizes.breakLaptop}) {
      font-size: 14px;
    }

    .price {
      color: #0f0538;
      font-size: 18px;
      font-weight: 700;
      margin: 0 5px;
      @media screen and (min-width: ${(props) =>
          props.theme.screenSizes.breakSmall}) {
        font-size: 18px;
      }
      @media screen and (min-height: 850px) and (min-width: ${(props) =>
          props.theme.screenSizes.breakLaptop}) {
        font-size: 20px;
      }
      @media screen and (min-width: ${(props) =>
          props.theme.screenSizes.breakLaptop}) {
        font-size: 20px;
      }
    }
  }
  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    flex: 0.5;
    height: 115px;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    padding: 20px 0 0 20px;
    height: 216px;
  }
`;

const handleImageLoadFail = (e) => {
  e.target.src =
    process.env.REACT_APP_AWS_URL +
    "uploads/floorplans/default.png?h=500&w=620&zc=2";
};

function Image({ name, onClick, onKeyPress, selected, floorplan, tid }) {
  const { width } = useWindowSize();
  const priceText = JSON.parse(floorplan.price_desc);
  const isStudent = floorplan.bot_type === "Student";
  let unitsData = floorplan.units_data;

  if (isStudent) {
    unitsData = "0";
  }

  const hasUnitSpecial = () => {
    return !!floorplan.units && floorplan.units.some(unit => !!unit.specials);
} 

  return (
    <FloorplanImageWrapper
      onClick={onClick}
      onKeyPress={onKeyPress}
      tabIndex={selected ? "-1" : "0"}
      className="FloorplanImageWrapper"
      selected={selected}
    >
      <div className="image-container">
        {(!!floorplan.specials || hasUnitSpecial()) && <div className="floorploan-banner">
          <img src="/images/light-mode/specials.svg" alt="specials available" className="banner-image"/>
          {translate("Specials Available", language(tid))}</div>}
        <FloorplanImage
          className="FloorplanImage"
          onError={handleImageLoadFail}
          src={
            process.env.REACT_APP_AWS_URL +
            "uploads/floorplans/" +
            floorplan.src +
            "?h=500&w=620&zc=2"
          }
          alt={"floorplan " + name + " layout"}
        />
      </div>
      <FloorplanInfo>
        {unitsData === "1" && floorplan.units && (
          <div className="date">
            {!isStudent && translate("Available on: ", language(tid))}{" "}
            <span className="date-flag">
              {!isStudent
                ? moment(floorplan.unit_date_availability).format("MM/DD/YYYY")
                : translate("Available", language(tid))}
            </span>
          </div>
        )}
        {unitsData === "1" && !floorplan.units && !isStudent && (
          <div className="date">
            <div className="not-available">
              {" "}
              {translate("Not Available", language(tid))}
            </div>
          </div>
        )}
        {unitsData === "0" &&
          !floorplan.units &&
          floorplan.get_notified === 1 && (
            <div className="date">
              <div className="not-available">
                {" "}
                {translate("Not Available", language(tid))}
              </div>
            </div>
          )}
        {unitsData === "0" &&
          !floorplan.units &&
          floorplan.get_notified === 0 && (
            <div className="date">
              <div className="available">
                {translate("Available:", language(tid))}
              </div>
            </div>
          )}
        {unitsData === "0" && isStudent && floorplan.units && (
          <div className="date">
            <div className="available">
              {translate("Available", language(tid))}
            </div>
          </div>
        )}
        <div className="title">{floorplan.name}</div>
        {floorplan.floorplan_pricing !== "0" && floorplan.price_from !== 0 && (
          <div className="price-wrapper">
            {translate("Starting at:", language(tid))}{" "}
            <span className="price">
              ${" "}
              {floorplan.price_from
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            </span>
            /mo
          </div>
        )}
        {floorplan.price_from === 0 && floorplan.floorplan_pricing !== "0" && (
          <span className="price-wrapper no-price">{priceText[0].text}</span>
        )}
        {width >= 1024 && (
          <FloorplanDetails className="FloorplanDetails" data={floorplan} />
        )}
      </FloorplanInfo>
    </FloorplanImageWrapper>
  );
}

export default Image;
